import { steps } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

export default function StepsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="四步上手"
        tone="secondary"
        title="第一次参加福利活动，照着这四步走"
        desc="不用担心流程复杂，从挑活动到领奖励，整个路径其实很短，我们把每一步的关键点都写清楚了。"
      />

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {steps.map((item, index) => (
          <Reveal key={item.step} delay={index * 80}>
            <div className="relative h-full bg-background-50 border border-background-200 rounded-2xl p-5 md:p-6">
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-2xl bg-secondary-100 text-secondary-800 flex items-center justify-center text-2xl">
                  <i className={item.icon}></i>
                </span>
                <span className="font-heading text-3xl text-background-300">{item.step}</span>
              </div>
              <h3 className="mt-5 text-base md:text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              {index < steps.length - 1 && (
                <span className="hidden lg:flex absolute top-1/2 -right-5 w-4 h-4 items-center justify-center text-background-400">
                  <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}